/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleALeftIcon20Regular = forwardRef('ArrowShapeTriangleALeftIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 5.38a1.35 1.35 0 0 0-2.107-1.118l-6.829 4.62a1.35 1.35 0 0 0 0 2.236l6.83 4.62A1.35 1.35 0 0 0 14 14.62V5.38Zm-1.5.283v8.675L6.088 10 12.5 5.663Z" })));
});
